import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { IEquipmentMaintenanceTypeResponse } from "@app/shared/data-access/src/lib/resource-management/models/equipment";

export class EquipmentMaintenanceTypeConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.EquipmentMaintenanceServiceType;
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "sortOrder",
      title: "dicTable.sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IEquipmentMaintenanceTypeResponse[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(2,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
    ],
  };
}
